import React from "react";

function ChartRenderer({ chart }) {

    if (!chart) {

        return null;

    }

    return (

        <div

            style={{

                marginTop: 20,

                marginBottom: 20,

                padding: 20,

                border: "1px solid #d9d9d9",

                borderRadius: 10,

                background: "#fafafa"

            }}

        >

            <h3

                style={{

                    marginTop: 0

                }}

            >

                {chart.title || "Chart"}

            </h3>

            {

                chart.subtitle &&

                (

                    <p

                        style={{

                            color: "#666"

                        }}

                    >

                        {chart.subtitle}

                    </p>

                )

            }

            <div

                style={{

                    height: 280,

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    border: "2px dashed #cfcfcf",

                    borderRadius: 8,

                    color: "#888",

                    fontSize: 18

                }}

            >

                📊 Chart placeholder

            </div>

            <pre

                style={{

                    marginTop: 20,

                    overflowX: "auto",

                    background: "#fff",

                    padding: 10,

                    borderRadius: 6,

                    fontSize: 12

                }}

            >

                {JSON.stringify(chart, null, 2)}

            </pre>

        </div>

    );

}

export default ChartRenderer;